/**
 * Field Test Carousel - Feedback Text Toggle Functionality
 * Handles "See more/See less" functionality for long feedback texts
 */

class FieldTestCarousel {
  constructor(carouselId, translations = {}) {
    this.carouselId = carouselId;
    this.voirPlusText = translations.voirPlus || 'Voir plus';
    this.voirMoinsText = translations.voirMoins || 'Voir moins';
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initFeedbackToggle());
    } else {
      this.initFeedbackToggle();
    }
  }

  initFeedbackToggle() {
    const feedbackTexts = document.querySelectorAll(`#${this.carouselId} .card-feedback-text`);
    
    if (!feedbackTexts.length) return;

    feedbackTexts.forEach((feedbackText) => {
      const feedbackId = feedbackText.getAttribute('data-feedback-id');
      const toggleButton = document.querySelector(`.card-feedback-toggle[data-feedback-id="${feedbackId}"]`);
      
      if (!toggleButton) return;
      
      // Store original height
      feedbackText.dataset.originalHeight = feedbackText.scrollHeight;

      // Check for overflow
      // Since 'truncated' class is added in Liquid, we check if scrollHeight > clientHeight
      if (feedbackText.scrollHeight > feedbackText.clientHeight) {
        toggleButton.style.display = 'block';
        
        toggleButton.addEventListener('click', () => {
          this.handleToggle(feedbackText, toggleButton);
        });
      } else {
        // If not overflowing, ensure truncated class is removed (optional but cleaner)
        // or just leave it since it doesn't affect appearance if text is short
        // But we must NOT show the button.
      }
    });
  }

  handleToggle(feedbackText, toggleButton) {
    const isTruncated = feedbackText.classList.contains('truncated');
    const originalHeight = feedbackText.dataset.originalHeight;
    
    if (isTruncated) {
      // Show full text
      feedbackText.classList.remove('truncated');
      feedbackText.style.maxHeight = `${originalHeight}px`;
      toggleButton.querySelector('.toggle-text').textContent = this.voirMoinsText;
    } else {
      // Reduce text
      feedbackText.classList.add('truncated');
      feedbackText.style.maxHeight = '';
      toggleButton.querySelector('.toggle-text').textContent = this.voirPlusText;
    }
  }
}

// Initialize when script loads
if (typeof window.fieldTestCarouselInstances === 'undefined') {
  window.fieldTestCarouselInstances = {};
}

// Export for use in Liquid templates
window.FieldTestCarousel = FieldTestCarousel;
